import styled from 'styled-components';
import { font } from '../const/font';
import { marginStyle } from '../const/helpers';
import { colors } from '../const/color';
import TextProps from './text/types';

export const Content = styled.div<TextProps>`
  color: ${({ $color }) => ($color ? colors[$color] : 'inherit')};
  text-align: ${({ $align }) => ($align ? $align : 'inherit')};
  font-size: ${({ $size }) => ($size ? `${font.size[$size]}px` : 'inherit')};
  line-height: ${({ $size }) => ($size ? `${font.lineHeight[$size]}px` : 'auto')};
  font-family: ${({ $fontFamily }) => ($fontFamily ? font.family[$fontFamily] : font.family.aeonikRegular)};
  font-weight: ${({ $fontWeight }) => ($fontWeight ? font.weight[$fontWeight] : 'normal')};
  margin: ${({ $m }) => ($m ? `${$m.map(m => marginStyle(m)).join(' ')} !important` : '0')};
  display: ${({ $display }) => $display};
  ul,
  p {
    margin: 0;
  }
  ul {
    padding: 0 0 0 15px;
  }
  a {
    color: ${colors.primary};
  }
`;
